const loggingEndpointMethods = {
    LOG_INFORMATION: "log-information",
    LOG_WARNING: "log-warning",
    LOG_ERROR: "log-error",
    LOG_CRITICAL: "log-critical",
};

export default loggingEndpointMethods;
